import React from 'react';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Badge = styled('div')`
  position: relative;
  display: inline-block;
  font-size: 10px;
  line-height: 1;
  padding: 0.25em 0.4em;
  border-radius: 0.25rem;
  font-weight: bold;
  background: #ccc;
  border: 1px solid #fff;
  color: #296775;

  &.dot-marker {
    padding-left: 30px;
  }

  &.dot-marker:before {
    position: absolute;
    top: 4.5px;
    left: 5px;
    content: '';
    width: 7px;
    height: 7px;
    background-color: #fff;
    border-radius: 50%;
  }
`;

const StatusBadge = (props) => {
  const { status, dotMarker, translateData, stylesData } = props;

  const { t } = useAutoTranslation();

  if (!status || !translateData[status]) {
    return null;
  }

  return (
    <Badge
      className={dotMarker ? 'dot-marker' : ''}
      style={stylesData[status] || {}}
      data-testid="badge"
    >
      {t(translateData[status])}
    </Badge>
  );
};

export default StatusBadge;
